import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";

const points = [
  { t: "Tailored, never templated", d: "Shaped around how your business actually operates — your clients, your pace, your voice." },
  { t: "Strategic, not generic", d: "Considered structure decisions. Not off-the-shelf checklists." },
  { t: "Direction, not guesswork", d: "Clear input, sharp questions, confident direction from start to finish." },
  { t: "Built to be used daily", d: "Elegant systems that stay in place — long after the handover." },
];

export default function Difference() {
  return (
    <section data-testid="difference-section" className="py-24 sm:py-32 bg-[color:var(--charcoal)] text-[color:var(--bg-base)]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div {...fadeUp} className="lg:col-span-5">
          <p className="overline mb-6" style={{ color: "var(--gold)" }}>— The Difference</p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl tracking-tight leading-[1.08]">
            Not a stack of documents.
            <span className="italic text-[color:var(--sage)]"> A proper foundation.</span>
          </h2>
          <p className="mt-8 text-[color:var(--bg-base)]/70 leading-relaxed font-light">
            Work that changes how your business operates — from the first enquiry to the final delivery.
          </p>
        </motion.div>
        <motion.div {...fadeUp} className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-12">
          {points.map((p, i) => (
            <div key={p.t} className="border-t border-[color:var(--bg-base)]/15 pt-6">
              <p className="font-serif-display italic text-sm text-[color:var(--gold)] mb-3">0{i + 1}</p>
              <h3 className="font-serif-display text-2xl">{p.t}</h3>
              <p className="mt-3 text-sm text-[color:var(--bg-base)]/70 leading-relaxed">{p.d}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
